
// ------- [ product-recent.js ]  (standalone, works on ANY page)
;(function () {
  const RV_KEY = 'rv_handles'
  const MAX = 20

  function getCurrentHandle() {
    const parts = window.location.pathname.split('/').filter(Boolean)
    // only treat /products/{handle} as a product handle
    if (parts[0] === 'products' && parts[1]) return parts[1]
    return null
  }

  // record current product handle (product pages only)
  const curHandle = getCurrentHandle()
  if (curHandle) {
    const list = JSON.parse(localStorage.getItem(RV_KEY) || '[]').filter((h) => h !== curHandle)
    list.unshift(curHandle)
    localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, MAX)))
  }

  class RecentlyViewed extends HTMLElement {
    async connectedCallback() {
      const grid = this.querySelector('x-grid')
      if (!grid) return this.remove()

      const limit = Number(this.dataset.limit || 4)
      const cur = getCurrentHandle()

      const handles = JSON.parse(localStorage.getItem(RV_KEY) || '[]')
        .filter((h) => h && h !== cur)
        .slice(0, MAX)

      if (!handles.length) return this.remove()

      let added = 0

      for (const h of handles) {
        if (added >= limit) break

        try {
          const html = await fetch(`/products/${encodeURIComponent(h)}?view=card`, {
            credentials: 'same-origin',
          }).then((r) => r.text())

          const tmp = document.createElement('div')
          tmp.innerHTML = html.trim()

          // keep your existing selector
          const card = tmp.querySelector('#card-product') // ONLY in-stock (your theme logic)
          if (!card) continue

          grid.appendChild(card)
          added++
        } catch (e) {
          // ignore single product fetch failures
        }
      }

      if (added) {
        this.closest('.related.products')?.classList.remove('no-js-hidden')
      } else {
        this.remove()
      }
    }
  }

  if (!customElements.get('recently-viewed')) {
    customElements.define('recently-viewed', RecentlyViewed)
  }
})()
